/* ITC CART REBUILD 2026-09-14 - quick-add popup support. POPUP ONLY.
 * Nothing here touches the product page.
 *
 * JOB 1 - nothing looks chosen until it is chosen.
 *   snippets/itc-np-card.liquid deliberately holds the popup's Add to cart until
 *   the customer has actively tapped every option group ("BUG2 (LAST2 2026-07-11):
 *   require a COMPLETE option selection ... so a multi-option product can NEVER be
 *   added on its pre-selected default variant"). That gate stays exactly as it is.
 *   The confusion was that the popup OPENED with a colour and a size already
 *   highlighted, so it looked as though the choice had been made and the button was
 *   simply dead.
 *   We therefore clear the pre-ticked radios when the popup opens. The theme draws
 *   "selected" off :checked, so with nothing ticked nothing looks chosen - we are
 *   not fighting its styling, we are telling it the truth. Tapping an option ticks
 *   it the normal way and every existing handler runs untouched.
 *   An earlier attempt force-ENABLED the button instead. That was wrong: the gate
 *   also blocks the click, so the button looked alive and silently did nothing.
 *
 * JOB 2 - no price for a variant nobody picked.
 *   On a product whose variants are not all the same price, the popup was showing
 *   the first variant's price as if it were the price. While nothing is chosen we
 *   show "From <lowest>" instead. As soon as a variant is chosen the theme's own
 *   price rendering takes over again.
 *
 * JOB 3 - load the delivery data on demand.
 *   The popup opens on collection, home and search pages, where the 77 KB delivery
 *   lookup is deliberately NOT loaded. We fetch it the first time a customer
 *   actually opens a popup, so the home page still loads none of it.
 */
(function () {
  'use strict';

  var assetsRequested = false;

  function tag() { return document.querySelector('script[data-itc-map]'); }

  function loadAssets() {
    if (assetsRequested) return;
    assetsRequested = true;
    var t = tag();
    if (!t) return;
    var css = t.getAttribute('data-itc-css');
    if (css && !document.querySelector('link[href="' + css + '"]')) {
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = css;
      document.head.appendChild(l);
    }
    var map = t.getAttribute('data-itc-map');
    var deliv = t.getAttribute('data-itc-deliv');
    if (!map || !deliv || window.ITC_DELIVERY) return;
    var s1 = document.createElement('script');
    s1.src = map;
    s1.onload = function () {
      var s2 = document.createElement('script');
      s2.src = deliv;
      document.head.appendChild(s2);
    };
    document.head.appendChild(s1);
  }

  /** option groups that are a real choice (more than one value) */
  function realGroups(dlg) {
    var out = [];
    var fs = dlg.querySelectorAll('fieldset');
    for (var i = 0; i < fs.length; i++) {
      if (fs[i].querySelectorAll('label.variant-option__button-label').length > 1) out.push(fs[i]);
    }
    return out;
  }

  function money(cents, sample) {
    var n = (cents / 100).toFixed(2);
    var cur = (sample && sample.match(/[^\d.,\s]+/)) ? sample.match(/[^\d.,\s]+/)[0] : '$';
    return cur + n;
  }

  function showFromPrice(dlg) {
    var link = dlg.querySelector('a[href*="/products/"]');
    if (!link) return;
    var handle = (link.getAttribute('href') || '').split('/products/')[1];
    if (!handle) return;
    handle = handle.split('?')[0].split('#')[0];
    var el = dlg.querySelector('.price, [class*="price-item"]');
    if (!el) return;
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) return;
        var lo = null, hi = null;
        p.variants.forEach(function (v) {
          if (lo === null || v.price < lo) lo = v.price;
          if (hi === null || v.price > hi) hi = v.price;
        });
        if (lo === hi) return;                       // one price for everything: leave it alone
        if (dlg.dataset.itcDeselected !== '1') return;
        var sample = el.textContent || '';
        el.setAttribute('data-itc-price-stashed', sample.trim());
        el.textContent = 'From ' + money(lo, sample);
      })
      .catch(function () { /* leave the price exactly as the theme rendered it */ });
  }

  // deselect() removed 2026-09-14. Clearing the ticks fought Horizon's own
  // re-render and left the popup looking chosen but dead on a real phone.
  // snippets/itc-np-card.liquid now treats what is ticked as chosen instead.
  function deselect(dlg){ /* intentionally does nothing */ }

  function scan() {
    var dlgs = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < dlgs.length; i++) {
      if (dlgs[i].querySelector('form[action*="/cart/add"]')) {
        loadAssets();
        deselect(dlgs[i]);
      }
    }
  }

  function boot() {
    scan();
    // a closed popup is reset, so the next opening starts clean again
    document.addEventListener('click', function () { setTimeout(scan, 250); }, true);
    if (!window.MutationObserver) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.tagName === 'DIALOG' && !t.hasAttribute('open')) {
          delete t.dataset.itcDeselected;
        }
      }
      setTimeout(scan, 300);
    }).observe(document.body, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['open']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
